import { useRealTimeData } from "../hooks/useRealTimeData"
import AdminPanel from "../components/AdminPanel"

const AdminPage = () => {
  const { devices,  addDevice, removeDevice, updateThresholds, exportLogs } = useRealTimeData()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">System Administration</h1>
        <p className="text-gray-600">Manage devices, configure settings, and export data</p>
      </div>

      <AdminPanel
        devices={devices}
        onAddDevice={addDevice}
        onRemoveDevice={removeDevice}
        onUpdateThresholds={updateThresholds}
        onExportLogs={exportLogs}
      />
    </div>
  )
}

export default AdminPage
